import React from 'react'

const InsightsReporting = () => {
  return (
    <div>InsightsReporting</div>
  )
}

export default InsightsReporting